// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IntakeSection-module__layout___EWGhA {
  display: flex;
  align-items: center;
  gap: 16px;
}

.IntakeSection-module__line___xCEMk {
  flex: 1;
  min-width: 0;
  margin: 0;
  font-size: 14px;
  color: #3f3f46;
}

.IntakeSection-module__status___Svvja {
  font-weight: 600;
}

.IntakeSection-module__neutral___kH2nG {
  color: #18181b;
}

.IntakeSection-module__warn___Wkbp1 {
  color: #a16207;
}

.IntakeSection-module__alert___rqvRH {
  color: #b91c1c;
}

.IntakeSection-module__detail___z4E6p {
  color: #52525b;
}

.IntakeSection-module__button___DYnAQ {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: 1px solid #d4d4d8;
  border-radius: 6px;
  background: #ffffff;
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  color: #18181b;
  cursor: pointer;
}
.IntakeSection-module__button___DYnAQ:hover:not(:disabled) {
  border-color: #18181b;
}
.IntakeSection-module__button___DYnAQ:disabled {
  color: #a1a1aa;
  cursor: default;
}

.IntakeSection-module__icon___6aK5c {
  color: #71717a;
}

.IntakeSection-module__noReport___kkdNn {
  flex-shrink: 0;
  font-size: 13px;
  color: #a1a1aa;
}

.IntakeSection-module__error___ffnNf {
  margin: 8px 0 0;
  font-size: 13px;
  color: #b91c1c;
}

@container (max-width: 639px) {
  .IntakeSection-module__layout___EWGhA {
    flex-wrap: wrap;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/ProviderHudView/IntakeSection.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AACF;;AAEA;EACE,OAAA;EACA,YAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AACF;AACE;EACE,qBAAA;AACJ;AAEE;EACE,cAAA;EACA,eAAA;AAAJ;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,cAAA;EACA,eAAA;EACA,cAAA;AADF;;AAIA;EACE,eAAA;EACA,eAAA;EACA,cAAA;AADF;;AAGA;EACE;IACE,eAAA;EAAF;AACF","sourcesContent":[".layout {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.line {\n  flex: 1;\n  min-width: 0;\n  margin: 0;\n  font-size: 14px;\n  color: #3f3f46;\n}\n\n.status {\n  font-weight: 600;\n}\n\n.neutral {\n  color: #18181b;\n}\n\n.warn {\n  color: #a16207;\n}\n\n.alert {\n  color: #b91c1c;\n}\n\n.detail {\n  color: #52525b;\n}\n\n.button {\n  display: inline-flex;\n  flex-shrink: 0;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border: 1px solid #d4d4d8;\n  border-radius: 6px;\n  background: #ffffff;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 500;\n  color: #18181b;\n  cursor: pointer;\n\n  &:hover:not(:disabled) {\n    border-color: #18181b;\n  }\n\n  &:disabled {\n    color: #a1a1aa;\n    cursor: default;\n  }\n}\n\n.icon {\n  color: #71717a;\n}\n\n.noReport {\n  flex-shrink: 0;\n  font-size: 13px;\n  color: #a1a1aa;\n}\n\n.error {\n  margin: 8px 0 0;\n  font-size: 13px;\n  color: #b91c1c;\n}\n@container (max-width: 639px) {\n  .layout {\n    flex-wrap: wrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layout": `IntakeSection-module__layout___EWGhA`,
	"line": `IntakeSection-module__line___xCEMk`,
	"status": `IntakeSection-module__status___Svvja`,
	"neutral": `IntakeSection-module__neutral___kH2nG`,
	"warn": `IntakeSection-module__warn___Wkbp1`,
	"alert": `IntakeSection-module__alert___rqvRH`,
	"detail": `IntakeSection-module__detail___z4E6p`,
	"button": `IntakeSection-module__button___DYnAQ`,
	"icon": `IntakeSection-module__icon___6aK5c`,
	"noReport": `IntakeSection-module__noReport___kkdNn`,
	"error": `IntakeSection-module__error___ffnNf`
};
module.exports = ___CSS_LOADER_EXPORT___;
